import React from "react";
import { useTranslation } from "react-i18next";

import "./index.less";
export const GatewayIntegrationFunctionsMobile = () => {
  const { t } = useTranslation();
  const bannerList = [
    {
      iconUrl: "//files.authing.co/authing-website/gateway-life-cycle-icon.png",
      title: t("gateway.functions.item1.title"),
      content: t("gateway.functions.item1.descript"),
      backgroundImg:
        "//files.authing.co/authing-website/gateway-life-cycle-bg.png",
      imgUrl: "//files.authing.co/authing-website/gateway-life-cycle-img.png",
    },
    // {
    //   iconUrl: "//files.authing.co/authing-website/gateway-flow-icon.png",
    //   title: t("gateway.functions.item2.title"),
    //   content: t("gateway.functions.item2.descript"),
    //   backgroundImg: "//files.authing.co/authing-website/gateway-flow-bg.png",
    //   imgUrl: "//files.authing.co/authing-website/gateway-flow-img.png",
    // },
    {
      iconUrl: "//files.authing.co/authing-website/gateway-warning-icon.png",
      title: t("gateway.functions.item3.title"),
      content: t("gateway.functions.item3.descript"),
      backgroundImg:
        "//files.authing.co/authing-website/gateway-warning-bg.png",
      imgUrl: "//files.authing.co/authing-website/gateway-warning-img.png",
    },
    {
      iconUrl: "//files.authing.co/authing-website/gateway-access-icon.png",
      title: t("gateway.functions.item4.title"),
      content: t("gateway.functions.item4.descript"),
      backgroundImg: "//files.authing.co/authing-website/gateway-access-bg.png",
      imgUrl: "//files.authing.co/authing-website/gateway-access-img.png",
    },
    {
      iconUrl: "//files.authing.co/authing-website/gateway-log-icon.png",
      title: t("gateway.functions.item5.title"),
      content: t("gateway.functions.item5.descript"),
      backgroundImg: "//files.authing.co/authing-website/gateway-log-bg.png",
      imgUrl: "//files.authing.co/authing-website/gateway-access-log.png",
    },
  ];
  return (
    <div className="mobile-gateway-functions">
      <div className="mobile-functions-title">
        {t("gateway.functions.title")}
      </div>
      <div className="moblie-banner-connection">
        {bannerList.map((item, index) => {
          return (
            <div
              className={`moblie-info-box bg${index}`}
              key={"moblie-info-box-item" + index}
            >
              <div className="moblie-info-box-item">
                <img
                  className="moblie-info-box-icon"
                  src={item.iconUrl}
                  alt="authing"
                />
                <div className="moblie-info-box-item-title">{item.title}</div>
                <div className="moblie-info-box-item-content">
                  {item.content}
                </div>
                <img
                  className="moblie-info-box-img"
                  src={item.imgUrl}
                  alt="authing"
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
